import {LiveblogEvent} from "@webng/liveblog";
import * as api from "./api";
import {debugIdForElement, tik4DebugLog} from "./debugLog";

export const tickarooInitEvent = "tickarooInit";

export const tickarooLiveblogInitEvent = "tickarooLiveblogInit";
export const tickarooLiveblogTeaserInitEvent = "tickarooLiveblogTeaserInit";

export const tickarooLiveblogTrackingEvent = "tickarooLiveblogTracking";
export const tickarooLiveblogTeaserTrackingEvent = "tickarooLiveblogTeaserTracking";

export const tickarooLiveblogCustomConsentEvent = "tickarooLiveblogCustomConsent";
export const tickarooLiveblogDataUpdatedEvent = "tickarooLiveblogDataUpdated";

export type InitEventDetail = typeof api;
export type LiveblogInitEventDetail = { liveblogId: string };
export type LiveblogTrackingEventDetail = LiveblogEvent;
export type LiveblogCustomerContestEventDetail = LiveblogEvent & {
  provider: string;
  consent: boolean;
};

export type LiveblogCustomerDataUpdatedDetail = {

}

export function fireInitEvent() {
  const initEvent = new CustomEvent<InitEventDetail>(tickarooInitEvent, {
    detail: api,
    bubbles: true,
    cancelable: false,
  });

  window.dispatchEvent(initEvent);
}

export function fireTickarooLiveblogInitEvent(
  el: Element,
  detail: LiveblogInitEventDetail
) {
  tik4DebugLog(debugIdForElement(el), "fireTickarooLiveblogInitEvent", detail);

  const event = new CustomEvent<LiveblogInitEventDetail>(
    tickarooLiveblogInitEvent,
    {
      detail: detail,
      bubbles: true,
      cancelable: false,
    }
  );

  el.dispatchEvent(event);
}

export function fireTickarooLiveblogTeaserInitEvent(
  el: Element,
  detail: LiveblogInitEventDetail
) {
  const event = new CustomEvent<LiveblogInitEventDetail>(
    tickarooLiveblogTeaserInitEvent,
    {
      detail: detail,
      bubbles: true,
      cancelable: false,
    }
  );

  el.dispatchEvent(event);
}

export function fireTickarooLiveblogTracking(
  el: Element,
  detail: LiveblogTrackingEventDetail
) {
  const event = new CustomEvent<LiveblogTrackingEventDetail>(
    tickarooLiveblogTrackingEvent,
    {
      detail: detail,
      bubbles: true,
      cancelable: false,
    }
  );

  el.dispatchEvent(event);
}

export function fireTickarooLiveblogTeaserTracking(
  el: Element,
  detail: LiveblogTrackingEventDetail
) {
  const event = new CustomEvent<LiveblogTrackingEventDetail>(
    tickarooLiveblogTeaserTrackingEvent,
    {
      detail: detail,
      bubbles: true,
      cancelable: false,
    }
  );

  el.dispatchEvent(event);
}

export function fireTickarooLiveblogCustomConsent(
  el: Element,
  detail: LiveblogCustomerContestEventDetail
) {
  const event = new CustomEvent<LiveblogCustomerContestEventDetail>(
    tickarooLiveblogCustomConsentEvent,
    {
      detail: detail,
      bubbles: true,
      cancelable: false,
    }
  );

  el.dispatchEvent(event);
}

export function fireTickarooLiveblogDataUpdated(
  el: Element,
  detail: LiveblogCustomerDataUpdatedDetail
) {
  const event = new CustomEvent<LiveblogCustomerDataUpdatedDetail>(
    tickarooLiveblogDataUpdatedEvent,
    {
      detail: detail,
    }
  )

  el.dispatchEvent(event)
}
